import FormFeedback from 'components/FormFeedback';
import FormProps from 'components/FormProps';
import CreateAccess from 'models/access/createAccess';
import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';

export type Props = FormProps<CreateAccess>;

export const Create = ({
  value, disabled, error, onChange,
}: Props) => {
  const handleControlChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!onChange) return;
    switch (event.target.name) {
      case 'companyName':
        onChange({ ...value, companyName: event.target.value }); break;
      case 'password':
        onChange({ ...value, password: event.target.value }); break;
      default: break;
    }
  };

  return (
    <>
      <Form.Group className="form-group">
        <InputGroup>
          <InputGroup.Text>Navn</InputGroup.Text>
          <Form.Control
            name="companyName"
            disabled={disabled}
            value={value.companyName}
            onChange={handleControlChange}
            isInvalid={error?.companyName !== undefined}
          />
          <FormFeedback type="invalid" values={error?.companyName} />
        </InputGroup>
      </Form.Group>
      <Form.Group className="form-group">
        <InputGroup>
          <InputGroup.Text>Download password</InputGroup.Text>
          <Form.Control
            name="password"
            type="password"
            disabled={disabled}
            value={value.password}
            onChange={handleControlChange}
            isInvalid={error?.password !== undefined}
          />
          <FormFeedback type="invalid" values={error?.password} />
        </InputGroup>
      </Form.Group>

    </>
  );
};

export default Create;
